import { Country, PageName } from '@utils/pageConfig/Types';
import { RetailerClientState } from './RetailerClientReducer';

export const constructRetailerClientState = (
  clientId: number,
  countries: Country[],
  clientName?: string,
  pageViewing?: PageName,
): RetailerClientState => {
  return {
    clientId: clientId,
    countries: countries,
    clientName: clientName,
    pageViewing: pageViewing,
  };
};
